import React, { useState, useLayoutEffect, useCallback } from 'react'
import styles from "./sidebar.module.scss"
import downArrowIcon from "images/sidebar_downArrow.png"
import SearchIcon from '@mui/icons-material/Search';
import LoopIcon from '@mui/icons-material/Loop';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import CloseIcon from '@mui/icons-material/Close';
import ReactLoading from 'react-loading';
import debounce from 'lodash/debounce';

const Sidebar = (props) => {
  const [radioValue, setRadioValue] = useState();
  const [filterInterface, setFilterInterface] = useState(false);
  const categoryNameRender = (data) => {
    switch (props.searchParams.get("lang")) {
      case 'en':
        return data[0][2]
      default:
        return data[0][1]
    }
  }
  const optionNameRender = (equalArray) => {
    switch (props.searchParams.get("lang")) {
      case 'en':
        return equalArray[2]
      default:
        return equalArray[1]
    }
  }
  const pushArrayInCategories = () => {
    let allCategoriesArray = []
    allCategoriesArray.push(props.placements, props.features, props.industries, props.devices, props.performances, props.deliverySystems)
    const filterAllCategoriesHiddenArray = allCategoriesArray.map((array) => {
      return array.filter(data => {
        if (data[3]) {
          return data[3].trim().toLowerCase() !== 'true'
        }
        return data
      })
    })
    const filterLayoutHiddenArray = props.layouts.filter((data) => {
      if (data[10]) {
        return data[10].trim().toLowerCase() !== 'true'
      }
      return data
    })
    filterAllCategoriesHiddenArray.push(filterLayoutHiddenArray)
    const concatArrays = props.placements.concat(props.features, props.industries, props.devices, props.performances, props.deliverySystems, props.layouts)
    return filterAllCategoriesHiddenArray.map((data) =>
      categoriesRender(data, concatArrays)
    )
  }
  const categoriesRender = (data, concatArrays) => {
    const dataKeys = data.slice(1).map((data) => data[0])
    const toggle = (e) => {
      const dropdownContent = e.nextElementSibling.nextElementSibling;
      if (dropdownContent.style.display === "none") {
        dropdownContent.style.display = "block";
        e.classList.remove(styles.upArrowIcon)
      } else {
        dropdownContent.style.display = "none";
        e.classList.add(styles.upArrowIcon)
      }
    }
    return (
      <div key={data[0]}>
        <img className={styles.downArrowIcon} alt='downArrowIcon' src={downArrowIcon} onClick={(e) => toggle(e.target)} />
        <label onClick={(e) => toggle(e.target.previousElementSibling)}>{categoryNameRender(data)}</label>
        <div>
          {dataKeys.map((dataKey, index) => translateFilter(dataKey, concatArrays, index))}
        </div>
      </div>
    )
  }
  const translateFilter = (dataKey, concatArrays, index) => {
    let equalArray = concatArrays.find(element => element[0] === dataKey);
    return (
      <div className={styles.category} key={index}>
        <input type="checkbox" id={dataKey} value={dataKey}
          onChange={(e) => {
            if (radioValue && Object.values(radioValue).includes(dataKey)) {
              const newArray = { ...radioValue }
              delete newArray[e.target.value]
              setRadioValue(newArray)
              props.getRatioValue(newArray)
            } else {
              setRadioValue({
                ...radioValue,
                [dataKey]: e.target.value,
              })
              props.getRatioValue({
                ...radioValue,
                [dataKey]: e.target.value,
              })
            }
          }}
        />
        <label htmlFor={dataKey}>{optionNameRender(equalArray)}</label>
      </div>
    )
  }
  const resetFilter = () => {
    props.getRatioValue({});
    setRadioValue({})
    const checkboxes = document.querySelectorAll('input[type="checkbox"]:checked');
    checkboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });
  }
  const debouncedGetInputValue = useCallback(
    debounce((value) => {
      props.getInputValue(value);
    }, 500),[]
  );

  useLayoutEffect(() => {
    const nav = document.querySelector('nav');
    if (filterInterface) {
      nav.classList.add(styles.active)
    } else {
      nav.classList.remove(styles.active)
    }
  }, [filterInterface])

  return !props.layouts ?
    (
      <nav className={styles.sidebar}>
        <div className={styles.container}>
          <div className={styles.search}>
            <button className={styles.searchButton}>
              <SearchIcon />
              <input onChange={(e) => debouncedGetInputValue(e.target.value)} />
            </button>
            <button onClick={resetFilter} className={styles.resetButton}>
              <LoopIcon />
            </button>
          </div>
          <div className={styles.loadingWrapper}>
            <ReactLoading type="bubbles" color="#5A24FF" height={'100px'} width={'100px'} />
          </div>
        </div>
      </nav>
    ) : (
      <>
        <div className={styles.filterContainer} >
          <FilterAltIcon sx={{ width: 40, height: 40, color: '#1E0078' }} className={styles.filterIcon} onClick={() => (setFilterInterface(!filterInterface))} />
        </div>
        <nav className={styles.sidebar}>
          <div className={styles.filterField}>
            <span>{props.searchParams.get("lang") === 'en' ? 'Filter' : '篩選'}</span>
            <div>
              <button onClick={resetFilter} className={styles.button}>
                <LoopIcon />
              </button>
              <button onClick={() => (setFilterInterface(!filterInterface))} className={styles.button}>
                <CloseIcon />
              </button>
            </div>
          </div>
          <div className={styles.container}>
            <div className={styles.search}>
              <button className={styles.searchButton}>
                <SearchIcon />
                <input onChange={(e) => debouncedGetInputValue(e.target.value)} />
              </button>
              <button onClick={resetFilter} className={styles.resetButton}>
                <LoopIcon />
              </button>
            </div>
            <div className={styles.content}>
              <div className={styles.categories}>
                {pushArrayInCategories()}
              </div>
            </div>
          </div>
        </nav>
      </>
    )
}
export default Sidebar